import { Link } from "react-router-dom";

export default function AboutIntro() {
  return (
    <section className="bg-[#f0f9f9] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden w-full h-[420px] md:h-[520px]">
              <img
                src="/images/about1.jpg"
                alt="Welcoming counseling office"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating accent card */}
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-white rounded-xl p-5 border border-[#c8e8e6] max-w-[200px]">
              <p className="text-[#418b86] text-3xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>8+</p>
              <p className="text-[#6b6b6b] text-xs mt-1 leading-snug">Years helping people find clarity and peace</p>
            </div>
          </div>

          {/* Content */}
          <div className="lg:pl-4">
            <p className="text-[#418b86] text-sm font-medium tracking-widest uppercase mb-4">You're Not Alone in This</p>
            <h2 className="text-3xl md:text-4xl font-light text-[#2d2d2d] leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              A place where you can<br />
              <span className="italic font-semibold">breathe, reflect, and grow.</span>
            </h2>
            <p className="text-[#5a5a5a] text-base leading-relaxed mb-5">
              You may be feeling overwhelmed, stuck, or simply exhausted. Maybe you've been carrying something heavy for a long time, and you're not sure where to start.
            </p>
            <p className="text-[#5a5a5a] text-base leading-relaxed mb-8">
              At Clarity Point Counseling, we believe healing begins with being truly heard. Our approach is warm, collaborative, and entirely focused on you — your story, your pace, your goals.
            </p>

            {/* Stats Row */}
            <div className="flex items-center gap-8 mb-8 pb-8 border-b border-[#c8e8e6]">
              {[
                { value: "500+", label: "Clients Supported" },
                { value: "98%", label: "Would Recommend" },
                { value: "20min", label: "Free Consultation" },
              ].map((stat) => (
                <div key={stat.label}>
                  <p className="text-[#418b86] text-xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>{stat.value}</p>
                  <p className="text-[#8a8a8a] text-xs mt-0.5">{stat.label}</p>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-[#418b86] font-medium text-sm hover:gap-3 transition-all duration-200 cursor-pointer"
            >
              Meet Your Counselor
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
